const validTours = {
  'contact-tour': true,
  contacts: true,
  'contacts-import': true,
  'create-contact': true,
  'create-contact-from-segmentation': true,
  'edit-theme-settings': true,
  'create-and-explore-meetings': true,
  'create-and-explore-meetings-without-connect-calendar': true,
  'create-first-marketing-email': true,
  'contacts-and-contact-record-explore-1': true,
  'contacts-and-contact-record-explore-2': true,
  'create-deal-1': true,
  'create-deal-2': true,
  'create-email-1': true,
  'create-email-2-with-send': true,
  'create-email-3': true,
  'create-embedded-form-from-type-page': true,
  'create-embedded-form-from-type-page-starter': true,
  'create-embedded-form-quickly': true,
  'create-sms-1': true,
  'edit-deal-stages': true,
  'edit-deal-stages-extended': true,
  'email-framework': true,
  'sms-edit': true,
  'sms-settings': true,
  'sms-sending': true,
  'sms-learn-more': true,
  'filter-contacts': true,
  'filter-contacts-with-property-search': true,
  'free-lp-onboarding-1': true,
  'free-lp-onboarding-2': true,
  'free-lp-onboarding-3': true,
  'free-lp-onboarding-4': true,
  'go-to-getting-started': true,
  'import-tour': true,
  'new-contact-tour': true,
  profile: true,
  'publish-and-edit-content': true,
  'publish-and-edit-editor': true,
  'quick-import': true,
  test: true,
  'academy-tour': true,
  'new-contact-record': true,
  'imported-contacts-post-signup': true,
  'create-email-list-with-filter': true,
  'create-email-v1-1': true,
  'create-email-v1-2': true,
  'create-email-v2-1': true,
  'create-email-v2-2': true,
  'create-email-v2-3': true,
  'control-center-custom-views-pages': true,
  'control-center-custom-views-blog-posts': true,
  'control-center-pages-revamp-no-custom-views': true,
  'control-center-blog-posts-revamp-no-custom-views': true,
  'cms-approval-status-column': true,
  'cms-approval-status-column-admin': true,
  'skip-data-sync-setup': true,
  'data-sync-setup-not-complete': true,
  'data-sync-setup-complete': true,
  'data-sync-flow': true,
  'data-sync-contacts': true,
  'download-email-extension': true,
  'listing-lib': true,
  'listing-lib-folders': true,
  'select-sales-email-template': true,
  'set-up-deals-pipeline': true,
  'sales-reporting-dashboards': true,
  'marketing-reporting-dashboards': true,
  'create-sales-reporting-dashboard': true,
  'create-marketing-reporting-dashboard': true,
  'rename-deal-pipeline': true,
  'explore-payments-tool': true,
  'discover-more-ways-to-get-paid': true,
  'workflows-index': true,
  'object-lists-views': true,
  'sales-reporting': true,
  'object-lists-views-or-filters': true,
  'post-import-contacts': true,
  'post-contact-wizard': true,
  'skip-setup-contacts': true,
  // TODO: deprecate post-enroll-... for payments-activation-professional-services-use
  'post-enroll-professional-services-use': true,
  'payments-activation-professional-services-create': true,
  // TODO: enable when post-enroll-... deprecated
  'payments-activation-professional-services-use': false,
  'payments-activation-subscriptions-create': true,
  'payments-activation-subscriptions-use': true,
  'payments-activation-paid-content-create': true,
  'payments-activation-paid-content-use': true,
  'payments-activation-projects-create': true,
  'payments-activation-projects-use': true,
  'payments-activation-physical-goods-create': true,
  'payments-activation-physical-goods-use': true,
  'payments-activation-donations-create': true,
  'payments-activation-donations-use': true,
  'comment-onboarding': true,
  'post-setup-deals-pipeline-in-app-side-panel': true,
  'post-setup-tickets-pipeline-in-app-side-panel': true,
  'post-setup-contacts-in-app-side-panel': true,
  'post-setup-email-synced-contacts-1': true,
  'post-setup-email-synced-contacts-2': true,
  'post-setup-email-synced-contacts-3': true,
  'post-setup-email-not-synced-contacts-1': true,
  'post-setup-email-not-synced-contacts-2': true,
  'post-setup-email-not-synced-contacts-3': true,
  'in-app-side-panel-deal-stages': true,
  'in-app-side-panel-ticket-stages': true,
  'in-app-side-panel-views': true,
  'in-app-side-panel-properties': true,
  'in-app-side-panel-lists': true,
  'in-app-side-panel-reports-dashboard': true,
  'template-empty-state': true,
  'create-template': true,
  'create-template-minimizable': true,
  postWizardDashboard: true
};
export default validTours;